import api from './client';

// Аварийный режим «Продажи без оприходования» (сбой ЭДО) — unreceived_sales.md v3

export interface UnreceivedSettings {
  enabled: boolean;
}

export interface UnreceivedItem {
  id: number;
  name: string;
  marking_code: string;
  gtin: string | null;
  serial_number: string | null;
  product_type: 'piece' | 'bulk' | string;
  quantity: number;
  price: number;
  unit: string | null;
  external_1c_id: string | null;
  sum: number;
  resolved_at: string | null;
  resolved_note: string | null;
  raw_code: string | null;
  has_full_code: boolean;
  in_shut: boolean | null;
}

export interface UnreceivedOrder {
  order_id: number;
  number: string | null;
  created_at: string | null;
  counterparty: string | null;
  pending_sum: number;
  items: UnreceivedItem[];
}

export interface UnreceivedReport {
  enabled: boolean;
  orders: UnreceivedOrder[];
}

export interface UnreceivedCheckOrder {
  order_id: number;
  number: string | null;
  all_found: boolean;
  items: { id: number; marking_code: string; name: string; found: boolean }[];
}

export interface UnreceivedCheckResult {
  checked_at: string;
  orders: UnreceivedCheckOrder[];
  from_cache: boolean;
}

export const unreceivedApi = {
  getSettings: () => api.get<UnreceivedSettings>('/unreceived/settings'),
  setSettings: (enabled: boolean) => api.put<UnreceivedSettings>('/unreceived/settings', { enabled }),
  getReport: (params: { date_from?: string; date_to?: string; include_resolved?: boolean }) =>
    api.get<UnreceivedReport>('/unreceived/report', { params }),
  checkIn1C: (orderId?: number) =>
    api.post<UnreceivedCheckResult>('/unreceived/check-1c', { order_id: orderId ?? null }),
  resolveItem: (id: number, note?: string) =>
    api.post<UnreceivedItem>(`/unreceived/items/${id}/resolve`, { note: note ?? null }),
  // Резолв товара для неоприходованной марки (схема §1А): режим ON + марка подходит
  // → product_id (из марки или связки по фасовке); иначе 404/409.
  // Код — query-параметр: марки содержат `/`, `*`, `%`, path-параметр ломает роутинг
  resolveForDraft: (markingCode: string) =>
    api.get<{ product_id: string; product_name: string | null; unreceived: boolean }>(
      '/unreceived/resolve-for-draft',
      { params: { marking_code: markingCode } }
    ),
};
